import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle } from 'lucide-react';
export function CountdownTimer() {
  // Initialize with 14h 8m 20s in seconds
  const [timeLeft, setTimeLeft] = useState(14 * 3600 + 8 * 60 + 20);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="w-full max-w-2xl mx-auto text-center" data-id="element-74">
      <div className="flex items-center justify-center gap-2 text-red-500 font-bold tracking-widest text-sm md:text-base mb-6" data-id="element-75">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-76" />
        <span data-id="element-77">PRECIO DE RELANZAMIENTO — CIERRA EN:</span>
      </div>

      <div className="flex justify-center gap-4 md:gap-8 mb-8" data-id="element-78">
        <div className="flex flex-col items-center" data-id="element-79">
          <div className="bg-dark-card border border-dark-border rounded-lg w-20 h-24 md:w-24 md:h-28 flex items-center justify-center shadow-[0_0_15px_rgba(212,168,67,0.1)]" data-id="element-80">
            <span className="text-4xl md:text-5xl font-heading font-bold text-white" data-id="element-81">
              {formatTime(hours)}
            </span>
          </div>
          <span className="text-gray-400 text-sm mt-2 font-medium uppercase tracking-wider" data-id="element-82">
            hs
          </span>
        </div>

        <div className="text-4xl md:text-5xl font-heading font-bold text-dark-border self-start mt-4 md:mt-6" data-id="element-83">
          :
        </div>

        <div className="flex flex-col items-center" data-id="element-84">
          <div className="bg-dark-card border border-dark-border rounded-lg w-20 h-24 md:w-24 md:h-28 flex items-center justify-center shadow-[0_0_15px_rgba(212,168,67,0.1)]" data-id="element-85">
            <span className="text-4xl md:text-5xl font-heading font-bold text-white" data-id="element-86">
              {formatTime(minutes)}
            </span>
          </div>
          <span className="text-gray-400 text-sm mt-2 font-medium uppercase tracking-wider" data-id="element-87">
            min
          </span>
        </div>

        <div className="text-4xl md:text-5xl font-heading font-bold text-dark-border self-start mt-4 md:mt-6" data-id="element-88">
          :
        </div>

        <div className="flex flex-col items-center" data-id="element-89">
          <div className="bg-dark-card border border-dark-border rounded-lg w-20 h-24 md:w-24 md:h-28 flex items-center justify-center shadow-[0_0_15px_rgba(212,168,67,0.1)]" data-id="element-90">
            <span className="text-4xl md:text-5xl font-heading font-bold text-white" data-id="element-91">
              {formatTime(seconds)}
            </span>
          </div>
          <span className="text-gray-400 text-sm mt-2 font-medium uppercase tracking-wider" data-id="element-92">
            seg
          </span>
        </div>
      </div>

      <div className="flex items-center justify-center gap-2 text-gold-light mb-8 bg-gold/10 inline-flex px-4 py-2 rounded-full border border-gold/20" data-id="element-93">
        <AlertTriangle className="w-4 h-4" data-id="element-94" />
        <span className="text-sm font-medium" data-id="element-95">Después sube. No vuelve.</span>
      </div>

      <div className="max-w-md mx-auto" data-id="element-96">
        <div className="flex justify-between text-sm mb-2" data-id="element-97">
          <span className="text-red-400 font-medium flex items-center gap-2" data-id="element-98">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-99"></span>
            Cupos al precio de relanzamiento
          </span>
          <span className="text-white font-bold" data-id="element-100">
            71% de los cupos ya tomados
          </span>
        </div>
        <div className="h-3 w-full bg-dark-card rounded-full overflow-hidden border border-dark-border" data-id="element-101">
          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: '71%'
        }} transition={{
          duration: 1.5,
          ease: 'easeOut'
        }} className="h-full bg-gradient-to-r from-red-600 to-amber-500 rounded-full relative" data-id="element-102">
            {/* Shimmer effect */}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full animate-[shimmer_2s_infinite]" data-id="element-103" />
          </motion.div>
        </div>
      </div>
    </div>;
}